import { render, staticRenderFns } from "./IntegrationDocs.vue?vue&type=template&id=501a7356"
import script from "./IntegrationDocs.vue?vue&type=script&lang=js"
export * from "./IntegrationDocs.vue?vue&type=script&lang=js"
import style0 from "./IntegrationDocs.vue?vue&type=style&index=0&id=501a7356&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports